import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-nav_arrow_left_1",
  "use": "icon-nav_arrow_left_1-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-nav_arrow_left_1\"><path d=\"m15.844 21.103c-.256 0-.512-.098-.707-.293l-7.697-7.697c-.284-.284-.44-.661-.44-1.062s.157-.777.44-1.061l7.696-7.697c.391-.391 1.023-.391 1.414 0s.391 1.023 0 1.414l-7.344 7.345 7.344 7.344c.391.391.391 1.023 0 1.414-.195.195-.45.293-.706.293z\" fill=\"#666666\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/nav_arrow_left_1.svg
// module id = ZdpK
// module chunks = 87